export class Hashing {
    public static GetHashedString(text: string) {
        return text.split("").reduce(function (a, b) {
            a = ((a << 5) - a) + b.charCodeAt(0);
            return a & a;
        }, 0).toString();
    }
}